module.exports = {
  ACTUAL: 'actual',
  REALTIME: 'realtime',
  PROJECTION: 'projection',

  PREVIOUS_PERIOD: 'previous',
  LAST_30_DAYS: 'last30',
  TARGET: 'target'
}
